import { Component, OnInit } from '@angular/core';
import { TabNavigationService } from '@app/navigation/components/tab-navigation/tab-navigation.service';
import { TabNavigationItem } from '@app/navigation/navigation.model';
import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';
import { TrackerService } from '@app/shared/services/tracker.service';
import {
  PathwayFacade,
  PathwayViewModel,
  getTabList,
  PathwayDataAPI,
} from '@dg/pathways-rsm';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'dgx-pathway-page',
  templateUrl: './pathway-page.component.html',
})
export class PathwayPageComponent
  extends SubscriberBaseDirective
  implements OnInit
{
  public vm$: Observable<PathwayViewModel>;
  public tabList: TabNavigationItem[];

  constructor(
    private api: PathwayDataAPI,
    private facade: PathwayFacade,
    private translate: TranslateService,
    private tabNavigationService: TabNavigationService,
    private trackerService: TrackerService
  ) {
    super();
    this.vm$ = this.facade.vm$;
  }
  public ngOnInit(): void {
    this.trackerService.setLocation('Pathway');

    // Pathway view tracking - important to only call those once per pathway view for correct metrics
    const { pathway, tltag } = this.facade.snapshot;
    this.trackerService.trackEventData({
      action: 'Pathway Viewed',
      properties: {
        isEndorsed: pathway.isEndorsed,
      },
    });

    this.trackReportsPathwayViewed(pathway.id, tltag);

    this.tabList = getTabList(
      this.facade.snapshot.permissions?.canViewEnrolleesTab,
      this.facade.snapshot.permissions?.canViewInsightsTab,
      this.translate,
      this.tabNavigationService
    );
  }

  private async trackReportsPathwayViewed(pathId: number, tlTag: string) {
    await this.api.trackReportsPathwayViewed({
      pathId,
      tlTag,
    });
  }
}
